export default __webpack_public_path__ + "static/zigzag-arrow-5c098bee68587e802d77841e0552f3c5.png";